import { ConditionsForm } from '../types';

const getNumberValue = (text): number | undefined => {
  const matches = text.match(/\d+/g);
  if (matches === null) return undefined;

  return Number(matches[0]);
};

export const getValues = (text: string | null | undefined): ConditionsForm => {
  const values: ConditionsForm = {
    firstConditionExist: false,
    firstFieldValues: {
      amount: undefined,
      year: undefined
    }
  };
  if (!text) return values;

  const conditions = text.split('. ');
  const firstCondition = conditions.find((condition) => condition.includes('You will have to pay $'));
  if (firstCondition) {
    const [firstPart, secondPart] = firstCondition.split('at the end of year');
    const amount = getNumberValue(firstPart);
    const year = getNumberValue(secondPart);

    values.firstConditionExist = true;
    values.firstFieldValues = {
      amount,
      year
    };
  }

  return values;
};

export const formatConditionsForm = (data: ConditionsForm) => {
  const {
    firstConditionExist,
    firstFieldValues
  } = data;

  let conditions: string = '';
  if (firstConditionExist) {
    const { amount, year } = firstFieldValues;
    conditions += `You will have to pay $${amount} at the end of year ${year}. `;
  }

  return conditions;
};
